import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "file-pdf",
  "use": "file-pdf-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"file-pdf\"><path d=\"M224 400H70c-19 0-32-13-32-32V237c0-16 13-32 32-32h308c19 0 32 13 32 32v128c0 19-13 32-32 32-52 3-103 3-154 3zm-35-45h38c23-3 39-13 42-32 3-6 3-16 3-22 0-26-16-39-38-42-13-3-23-3-36-3h-9v99zm-87-96v99h26v-16-16h19c16-6 26-19 26-38 0-16-10-29-29-29-13-3-29 0-42 0zm247-3h-58v99h26v-38h29v-23h-29v-19h32v-19zM96 192H80v-38V32c0-19 13-32 32-32h243c3 0 7 0 10 3 35 35 70 71 105 106 4 3 4 6 4 6v362c0 19-13 32-32 32H112c-19 0-32-13-32-32v-55-6h16v58c0 12 6 19 19 19h330c9 0 16-7 16-19V314 118c0-6-3-9-10-9h-57c-20 0-32-13-32-32V19c0-6-4-9-10-9H115c-13 6-19 12-19 25v157zm339-93c-19-19-38-38-57-61v45c0 10 6 16 12 16h45zM218 333c19 0 28-7 28-26 0-22-6-29-28-25v51zm-74-39c3-3 3-9 0-12-3-4-10-4-16-4v23c6 0 13 0 16-7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/file-pdf.svg
// module id = 183
// module chunks = 0